const payEstimateDetailTitleBarMenu = {
  contentType: "payEstimateDetail",
  menuItems: [
    {
      _menuId: "payEstimateDetailMenu_1",
      type: "TITLEBAR_MENU_ITEM",
      label: "New QSheet",
      action: "newQSheet",
    },
    {
      _menuId: "payEstimateDetailMenu_2",
      type: "TITLEBAR_MENU_SEPARATOR",
    },
    {
      _menuId: "payEstimateDetailMenu_3",
      type: "TITLEBAR_MENU_ITEM",
      label: "Close Estimate",
      action: "closeEstimate",
    },
    {
      _menuId: "payEstimateDetailMenu_4",
      type: "TITLEBAR_MENU_SEPARATOR",
    },
    {
      _menuId: "payEstimateDetailMenu_5",
      type: "TITLEBAR_MENU_ITEM",
      label: "Close Tab",
      action: "closeTab",
    },
  ],
  toolbar: [
    {
      _iconId: "payEstimateDetailToolbar_1",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "sync-alt",
      toggleValue: null,
      action: "refresh",
      toolTipText: "Refresh",
    },
  ],
};

export default payEstimateDetailTitleBarMenu;
